"use client"

import Link from 'next/link';

/**
 * Catch-all route for unmatched paths within the (main) layout group.
 * Renders inside the Shell so tabs, sidebar, and WebSocket stay alive.
 * Without this, unmatched routes hit Next.js's global 404 which unmounts the Shell.
 */
export default function CatchAll() {
  return (
    <div className="flex flex-col items-center justify-center h-64 text-center">
      <h2 className="text-2xl font-semibold text-gray-800 mb-2">Page not found</h2>
      <p className="text-sm text-gray-500 mb-4">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <Link
        href="/"
        className="text-sm text-teal-600 hover:text-teal-700 underline"
      >
        Go to workspace
      </Link>
    </div>
  );
}
